// Centralized frontend configuration
import { resolveApiBase } from './lib/apiBase';

// Force direct connection to backend on port 5001 in development
// The proxy is not working reliably, so we use direct connection
const getApiUrl = () => {
  if (typeof window === 'undefined') {
    return resolveApiBase();
  }
  
  // In development on localhost, always use direct backend connection
  if (process.env.NODE_ENV === 'development') {
    const hostname = window.location?.hostname || '';
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      // Use direct backend connection
      return 'http://localhost:5001';
    }
  }
  
  return resolveApiBase();
};

export const API_URL = getApiUrl();

export const OCR_URL =
  process.env.REACT_APP_OCR_URL ||
  (typeof window !== 'undefined' && window.__OCR_URL__) ||
  'http://localhost:5001';

export const PDF_WORKER_URL =
  process.env.REACT_APP_PDF_WORKER_URL ||
  (typeof window !== 'undefined' && window.__PDF_WORKER_URL__) ||
  '/pdf.worker.min.js';
